import { useMemo } from "react";
import { Play } from "lucide-react";
import { imgUrl } from "./PropertyCard";

// Detect YouTube/Vimeo and produce embed URL
export function getVideoEmbed(video) {
  if (!video) return null;
  const { kind, url } = video;
  if (kind === "upload") return { type: "file", src: imgUrl({ url }) };
  if (kind === "youtube") {
    const m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
    const id = m ? m[1] : url.split("/").pop();
    return { type: "iframe", src: `https://www.youtube.com/embed/${id}` };
  }
  if (kind === "vimeo") {
    const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    const id = m ? m[1] : url.split("/").pop();
    return { type: "iframe", src: `https://player.vimeo.com/video/${id}` };
  }
  // Fallback: try to detect from URL
  if (/youtu/.test(url)) return getVideoEmbed({ kind: "youtube", url });
  if (/vimeo/.test(url)) return getVideoEmbed({ kind: "vimeo", url });
  return { type: "file", src: imgUrl({ url }) };
}

export const VideoPlayer = ({ video, className = "", autoplay = false, muted = true, loop = false, controls = true }) => {
  const embed = useMemo(() => getVideoEmbed(video), [video]);
  if (!embed) return null;
  if (embed.type === "iframe") {
    const params = new URLSearchParams({
      autoplay: autoplay ? "1" : "0",
      mute: muted ? "1" : "0",
      muted: muted ? "1" : "0",
      loop: loop ? "1" : "0",
      controls: controls ? "1" : "0",
    });
    return (
      <iframe
        src={`${embed.src}?${params.toString()}`}
        className={className}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Vidéo"
      />
    );
  }
  return (
    <video
      src={embed.src}
      className={className}
      autoPlay={autoplay}
      muted={muted}
      loop={loop}
      controls={controls}
      playsInline
    />
  );
};

export const VideoThumb = ({ video, onClick, className = "" }) => (
  <button type="button" onClick={onClick} className={`relative bg-slate-900 ${className}`}>
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="w-14 h-14 bg-[#FFC107] border border-slate-900 flex items-center justify-center">
        <Play className="w-6 h-6" strokeWidth={2.5} fill="currentColor" />
      </div>
    </div>
    <div className="absolute bottom-2 left-2 text-white text-xs font-bold uppercase tracking-wider">{video.title || "Vidéo"}</div>
  </button>
);
